import { ReactComponent as BrizTVIcon } from '../../../assets/images/brizTvApps/icons/BrizTv.svg';
import { ReactComponent as BrizTVText } from '../../../assets/images/brizTvApps/texts/BrizTv.svg';
import { ReactComponent as GooglePlayIcon } from '../../../assets/images/brizTvApps/icons/GooglePlay.svg';
import { ReactComponent as GooglePlayText } from '../../../assets/images/brizTvApps/texts/GooglePlay.svg';
import { ReactComponent as AndroidTvIcon } from '../../../assets/images/brizTvApps/icons/AndroidTv.svg';
import { ReactComponent as AndroidTvText } from '../../../assets/images/brizTvApps/texts/AndroidTv.svg';
import { ReactComponent as AppStoreIcon } from '../../../assets/images/brizTvApps/icons/AppStore.svg';
import { ReactComponent as AppStoreText } from '../../../assets/images/brizTvApps/texts/AppStore.svg';
import { ReactComponent as AppleTvIcon } from '../../../assets/images/brizTvApps/icons/AppleTv.svg';
import { ReactComponent as AppleTvText } from '../../../assets/images/brizTvApps/texts/AppleTv.svg';
import { ReactComponent as TizenTvIcon } from '../../../assets/images/brizTvApps/icons/TizenTv.svg';
import { ReactComponent as SamsungText } from '../../../assets/images/brizTvApps/texts/Samsung.svg';
import { ReactComponent as LgIcon } from '../../../assets/images/brizTvApps/icons/Lg.svg';
import { ReactComponent as LgText } from '../../../assets/images/brizTvApps/texts/Lg.svg';
import { BrizTvApp } from '../../../models/Common';

export const brizTvSite: BrizTvApp = {
  icon: BrizTVIcon,
  title: 'lookOnSite',
  name: BrizTVText,
  description: 'pcTabletsPhones',
  link: 'https://briz.tv?lang=ua',
};

export const brizTvApps: BrizTvApp[] = [
  {
    icon: GooglePlayIcon,
    title: 'availableIn',
    name: GooglePlayText,
    description: 'androidPhonesTablets',
    link: process.env.REACT_APP_BRIZ_TV_ANDROID ? `${process.env.REACT_APP_BRIZ_TV_ANDROID}&hl=uk` : '',
  },
  {
    icon: AppStoreIcon,
    title: 'uploadTo',
    name: AppStoreText,
    description: 'applePhonesTablets',
    link: process.env.REACT_APP_BRIZ_TV_APPLE || '',
  },
  {
    icon: TizenTvIcon,
    title: 'tvApp',
    name: SamsungText,
    description: 'tizenTv',
    hoverText: 'success.brizTv.searchInTv',
  },
  {
    icon: AndroidTvIcon,
    title: 'applicationFor',
    name: AndroidTvText,
    description: 'androidTvSetTopBoxes',
    link: process.env.REACT_APP_BRIZ_TV_ANDROID ? `${process.env.REACT_APP_BRIZ_TV_ANDROID}&hl=uk` : '',
  },
  {
    icon: AppleTvIcon,
    title: 'applicationFor',
    name: AppleTvText,
    description: 'appleSetTopBoxes',
    link: process.env.REACT_APP_BRIZ_TV_APPLE || '',
  },
  { icon: LgIcon, title: 'tvApp', name: LgText, description: 'webOS', link: process.env.REACT_APP_BRIZ_TV_LG || '' },
];
